var map = {
	"../app/components/speaker/calendar/calendar.module": [
		"./src/app/components/speaker/calendar/calendar.module.ts",
		"app-components-speaker-calendar-calendar-module"
	],
	"../app/components/speaker/myprofile/myprofile.module": [
		"./src/app/components/speaker/myprofile/myprofile.module.ts",
		"app-components-speaker-myprofile-myprofile-module"
	],
	"../app/components/speaker/mystory/mystory.module": [
		"./src/app/components/speaker/mystory/mystory.module.ts",
		"app-components-speaker-mystory-mystory-module"
	],
	"../app/components/speaker/training/training.module": [
		"./src/app/components/speaker/training/training.module.ts",
		"app-components-speaker-training-training-module"
	],
	"../app/components/speaker/trainingdetail/trainingdetail.module": [
		"./src/app/components/speaker/trainingdetail/trainingdetail.module.ts",
		"app-components-speaker-trainingdetail-trainingdetail-module"
	],
	"./components/authentication/forgotpassword/forgotpassword.module": [
		"./src/app/components/authentication/forgotpassword/forgotpassword.module.ts",
		"components-authentication-forgotpassword-forgotpassword-module"
	],
	"./components/authentication/reset-password/reset-password.module": [
		"./src/app/components/authentication/reset-password/reset-password.module.ts",
		"components-authentication-reset-password-reset-password-module"
	],
	"./components/speaker/cpwd/cpwd.module": [
		"./src/app/components/speaker/cpwd/cpwd.module.ts",
		"components-speaker-cpwd-cpwd-module"
	],
	"./components/speaker/eventdetails/eventdetails.module": [
		"./src/app/components/speaker/eventdetails/eventdetails.module.ts",
		"components-speaker-eventdetails-eventdetails-module"
	],
	"./components/speaker/expenses/expenses.module": [
		"./src/app/components/speaker/expenses/expenses.module.ts",
		"components-speaker-expenses-expenses-module"
	],
	"./components/speaker/privacy-policy/privacy-policy.module": [
		"./src/app/components/speaker/privacy-policy/privacy-policy.module.ts",
		"components-speaker-privacy-policy-privacy-policy-module"
	],
	"./components/speaker/speakerdashboard/speakerdashboard.module": [
		"./src/app/components/speaker/speakerdashboard/speakerdashboard.module.ts",
		"components-speaker-speakerdashboard-speakerdashboard-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;